import localizeCurrency from "@helpers/localizeCurrency"
import { getPlanDetails } from "@helpers/plans"
import { CheckIcon } from "@heroicons/react/24/outline"
import { PaymentIntent } from "@stripe/stripe-js"
import { useTranslation } from "react-i18next"
import { Plan } from "src/types"

interface TermsCheckboxProps {
  fullPrice: number
  isTermsAccepted: boolean
  paymentIntent: PaymentIntent | undefined
  plan: Plan
  setIsTermsAccepted: (isTermsAccepted: boolean) => void
}

export default function TermsCheckbox({
  fullPrice,
  isTermsAccepted,
  paymentIntent,
  plan,
  setIsTermsAccepted,
}: TermsCheckboxProps) {
  const { t } = useTranslation()

  if (!paymentIntent) return null

  const localizedFullPrice = localizeCurrency({
    amountInCents: fullPrice,
    currency: paymentIntent.currency,
  })

  return (
    <label
      className={`flex cursor-pointer gap-3 rounded-vm-md border p-3 transition-colors ${
        isTermsAccepted
          ? "border-vm-primary bg-vm-primary-soft"
          : "border-vm-line bg-vm-surface"
      }`}
      htmlFor="terms-checkbox"
    >
      <input
        checked={isTermsAccepted}
        className="peer sr-only"
        id="terms-checkbox"
        onChange={(event) => setIsTermsAccepted(event.target.checked)}
        type="checkbox"
      />
      <span
        aria-hidden
        className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border-2 transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-vm-primary/40 ${
          isTermsAccepted
            ? "border-vm-primary bg-vm-primary text-white"
            : "border-vm-muted/50 bg-vm-cream"
        }`}
      >
        {isTermsAccepted && (
          <CheckIcon className="h-3.5 w-3.5 animate-check-pop" />
        )}
      </span>

      <span className="text-xs leading-relaxed text-vm-ink">
        {t(getPlanDetails(plan).termsCheckboxLabelKey, {
          price: localizedFullPrice,
        })}
      </span>
    </label>
  )
}
